<ion-toolbar>
    <ion-title class="ion-text-center">{{ title }}</ion-title>
</ion-toolbar>
<ion-toolbar class="search-category-toolbar">
    <ion-input id="search" type="text" [(ngModel)]="searchQuery" placeholder="Search" [clearInput]="true"></ion-input>
</ion-toolbar>
<ion-content class="filter-category-modal-content">
    <div class="options-list">
        <div class="option-row" *ngFor="let item of filteredList; let i = index; trackBy: trackByIndex" (click)="toggle(item)">
            <ion-checkbox
                color="secondary"
                fill="outline"
                [checked]="item?.checked"
                (ionChange)="item.checked = $event.detail.checked"
                (click)="$event.stopPropagation()"
                [attr.aria-labelledby]="'option-label-' + i"
            ></ion-checkbox>
            <span class="option-label" [attr.id]="'option-label-' + i">{{ item?.display ?? item?.value }}</span>
        </div>
    </div>
</ion-content>
<ion-footer class="filter-category-modal-footer">
    <ion-toolbar>
        <div class="footer-actions">
            <ion-button class="filter-modal-footer-btn" type="button" color="secondary" fill="outline" (click)="close()">Cancel</ion-button>
            <ion-button class="filter-modal-footer-btn" type="button" color="secondary" (click)="apply()">Apply</ion-button>
        </div>
    </ion-toolbar>
</ion-footer>
